import {
  Toast,
  Dialog
} from 'vant'

export const showToast = str => {
  Toast({
    position: 'bottom',
    message: str
  })
}

showToast.success = msg => {
  Toast.success(msg)
}

export const showLoading = str => {
  Toast.loading({
    message: str || '加载中...',
    duration: 0,
    forbidClick: true
  })
}

export const hideLoading = () => {
  Toast.clear()
}

export const showAlert = params => {
  return Dialog.alert(Object.assign({
    message: '弹窗内容'
  }, typeof params === 'string' ? {
    message: params
  } : params))
}

/**
 * 验证手机号有效性
 * @param tel
 * @returns {boolean}
 */
export const checkTel = (tel) => {
  let reg = /^(1[0-9]{10})$/
  return reg.test(tel)
}

/**
 * 验证邮箱有效性
 * @param mail
 * @returns {boolean}
 */
export const checkMail = (mail) => {
  //var reyx = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
  var reyx = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return !(mail === "" || reyx.test(mail) === false);
}

export const getQueryString = (name)=> {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = decodeURI(window.location.search.substr(1)).match(reg);
  if (r != null)return unescape(r[2]);
  return null;
}

//判断是否安卓手机
export const isAndroid = () => {
  let u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}

/**
 * 判断是否为空
 * undefined => true
 * null => true
 * [] => true
 * {} => true
 * "" => true
 * "    " => true
 * @param target 目标
 * @returns {boolean}
 */
export function isEmpty(target) {
  if (target === undefined) return true;
  if (target === 'undefined') return true;
  if (target === null) return true;
  if (target === 'null') return true;
  if (target === '0') return true;
  if (isArray(target) && target.length === 0) return true;
  if (isObject(target) && Object.getOwnPropertyNames(target).length === 0) return true;
  if (isNumber(target) && target === -1) return true;
  if (`${target}`.trim().length === 0) return true;
  return false;
}

export function isString(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'String';
}

export function isNumber(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Number';
}

export function isBoolean(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Boolean';
}

export function isFunction(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Function';
}

export function isNull(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Null';
}

export function isUndefined(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Undefined';
}

export function isObject(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Object';
}

export function isArray(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Array';
}

export function isDate(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Date';
}

export function isRegExp(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'RegExp';
}

export function isError(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Error';
}

export function isSymbol(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Symbol';
}

export function isPromise(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Promise';
}

export function isSet(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Set';
}

export function getTimeFormatYYMMDD(time, symbol='-') {
  if (!time) return '';
  let dateStr = time;

  if (time.includes('T')) {
    dateStr = time.split('T')[0];
  }

  const cleanedDate = dateStr.replace(/[-/]/g, '');

  if (cleanedDate.length >= 8) {
    return `${cleanedDate.substr(0, 4)}${symbol}${cleanedDate.substr(4, 2)}${symbol}${cleanedDate.substr(6, 2)}`;
  }
  return dateStr;
}